// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*{margin:0;padding:0;box-sizing:border-box}html{font-size:16px}body,html{overflow-x:hidden}body{height:100%;overflow-y:auto;margin:0;padding:0}#app{width:100%;min-height:100vh;font-family:Microsoft YaHei,Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;overflow-x:hidden}", ""]);
// Exports
module.exports = exports;
